import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var areContextsTheSame = function areContextsTheSame(left, right) {
  return !Object.entries(left).every(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    return right.hasOwnProperty(k) && right[k] === v;
  });
};
export var isContextChanged = function isContextChanged(previousContext, newContext) {
  return previousContext && newContext && areContextsTheSame(previousContext, newContext) && areContextsTheSame(newContext, previousContext);
};